// Subdued payment methods row shown below the checkout button.
// Uses the same icons as Shopify checkout for complete visual consistency.

import { useT } from "@/lib/i18n";

type Method = { id: string; label: string; src: string };

const METHODS: Method[] = [
  {
    id: "mobilepay",
    label: "MobilePay",
    src: "https://farveladeland.myshopify.com/cdn/shopifycloud/checkout-web/assets/c1/assets/mobilepay.CTpQfBiI.svg",
  },
  {
    id: "visa",
    label: "Visa",
    src: "https://farveladeland.myshopify.com/cdn/shopifycloud/checkout-web/assets/c1/assets/visa.CjeXrSa5.svg",
  },
  {
    id: "mastercard",
    label: "Mastercard",
    src: "https://farveladeland.myshopify.com/cdn/shopifycloud/checkout-web/assets/c1/assets/master.BggvWv9L.svg",
  },
  {
    id: "dankort",
    label: "Dankort",
    src: "https://farveladeland.myshopify.com/cdn/shopifycloud/checkout-web/assets/c1/assets/dankort.BcTp4ial.svg",
  },
];

export function CartPaymentMethods() {
  const { locale } = useT();
  const heading = locale === "en" ? "We accept" : "Vi tager imod";
  return (
    <div className="pt-3">
      <p className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
        {heading}
      </p>
      <ul className="mt-2 flex flex-wrap items-center gap-1.5">
        {METHODS.map((m) => (
          <li key={m.id} title={m.label} aria-label={m.label}>
            <img
              src={m.src}
              alt={m.label}
              loading="lazy"
              className="h-6 w-auto opacity-90 transition-opacity hover:opacity-100"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
